import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SUPPORTED_LANGS } from '@constants';

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  constructor(private readonly translateService: TranslateService) {}

  public ensureLangsLoaded(): Promise<boolean> {
    this.translateService.addLangs(SUPPORTED_LANGS);

    return this.waitForLangsLoaded(SUPPORTED_LANGS).then(() => {
      this.translateService.setDefaultLang('pl');

      // WCAG 2.1
      this.updateHtmlLang(this.translateService.defaultLang);

      this.translateService.onLangChange.subscribe(({ lang }) => {
        this.updateHtmlLang(lang);
      });

      return true;
    });
  }

  private waitForLangsLoaded(langsArray: string[]): Promise<boolean> {
    return new Promise(resolve => {
      const intervalId = setInterval(() => {
        Promise.all(langsArray.map(lang => this.translateService.getTranslation(lang).toPromise()))
          .then(() => {
            clearInterval(intervalId);
            // eslint-disable-next-line no-console
            console.info('All languages loaded');
            resolve(true);
          })
          .catch(() => {
            // eslint-disable-next-line no-console
            console.warn('Waiting for languages...');
          });
      }, 500);
    });
  }

  private updateHtmlLang(lang: string) {
    if (!lang) {
      return;
    }

    document.documentElement.lang = lang;
  }
}
